import React, { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import PropTypes from 'prop-types';

import { RealizarBoletaScreen } from './RealizarBoletaScreen';
import { MisBoletasScreen } from './MisBoletasScreen';

function TabPanel( props ){
    
    const { children, value, index, ...other } = props;
  
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
  
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const TabsUsuarioExternoScreen = () => {

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
            
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant='scrollable' scrollButtons='auto' allowScrollButtonsMobile >
                    
                    <Tab label="Mis boletas" {...a11yProps(0)} />
                    <Tab label="Realizar boleta" {...a11yProps(1)} />

                </Tabs>

            </Box>

            <TabPanel value={value} index={0}>

                <MisBoletasScreen />

            </TabPanel>

            <TabPanel value={value} index={1}>

                <RealizarBoletaScreen />

            </TabPanel>

        </>
    )

}
